import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Realmente son 15 minutos o es solo marketing?',
    answer: 'Son 15 minutos REALES, cronometrados. El secreto está en el Batch Cooking del domingo donde preparas las bases (arroz, pollo, verduras cortadas). Durante la semana solo ensamblas. Hemos probado cada receta con familias reales y todas cumplen el tiempo prometido.'
  }, {
    question: '¿Funciona si vivo en [mi país]? ¿Conseguiré los ingredientes?',
    answer: '¡Sí! El sistema incluye una guía completa de Swaps Latinos con sustituciones específicas para México, Argentina, Colombia, Chile, Perú, Ecuador y más. Si un ingrediente no se consigue en tu país, te damos 2-3 alternativas locales que funcionan igual.'
  }, {
    question: '¿Qué pasa si mis hijos son muy selectivos para comer?',
    answer: "El 92% de las familias reportan que sus hijos comen sin protestar. ¿Por qué? Porque las recetas están diseñadas con sabores familiares, nada raro ni experimental. Además, incluimos una guía de 'Cómo Adaptar para Niños Selectivos' con trucos probados."
  }, {
    question: '¿Qué incluye exactamente el sistema?',
    answer: 'Recibes: 50 recetas de 15 minutos, 12 menús semanales completos, guía de Batch Cooking Express, listas de compras imprimibles, swaps por país, acceso a comunidad privada, y actualizaciones mensuales con recetas nuevas. Todo digital, descarga inmediata.'
  }, {
    question: '¿Hay garantía?',
    answer: 'Sí, 30 días de garantía total. Si implementas el sistema durante un mes y sientes que no te funciona, te devolvemos el 100% de tu dinero. Sin preguntas. Solo nos escribes y listo.'
  }];
  return <section className="bg-gray-50 py-12 sm:py-16 md:py-20" data-id="element-168">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-169">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12" data-id="element-170">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-3 sm:space-y-4" data-id="element-171">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border-2 border-orange-100 overflow-hidden" data-id="element-172">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between text-left hover:bg-orange-50 transition-colors" aria-expanded={openIndex === index} data-id="element-173">
                <span className="font-semibold text-sm sm:text-base md:text-lg text-gray-900 pr-4 leading-snug" data-id="element-174">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-orange-600 transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-175" />
              </button>
              {openIndex === index && <div className="px-4 sm:px-6 pb-4 sm:pb-5 text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-176">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}